import {
  //HomeOutlined,
  UserOutlined,
  LockOutlined,
  BankOutlined,
  ExperimentOutlined,
  DatabaseOutlined,
  TeamOutlined,
  ControlOutlined,
  InboxOutlined,
  SnippetsOutlined,
  FireOutlined,
  TagOutlined,
  DeliveredProcedureOutlined,
  FileImageOutlined ,
  FundOutlined 
 
  // Importa aquí todos los íconos que necesites
} from '@ant-design/icons';
import Source from 'src/components/Admin/Source';

const iconMap: { [key: string]: React.ComponentType } = {
  //ome: HomeOutlined,
  user: UserOutlined,
  change:LockOutlined,
  organization:BankOutlined,
  emission:ExperimentOutlined,
  category:DatabaseOutlined,
  emissions:ExperimentOutlined,
  factors:TeamOutlined,
  pcg:ControlOutlined,
  gei:InboxOutlined,
  result:SnippetsOutlined,
  sources: FireOutlined,
  tags : TagOutlined,
  typeevent:DeliveredProcedureOutlined,
  event:FileImageOutlined,
  typeorganization : TagOutlined,
  portfolio:FundOutlined ,
  portafoliogei:FundOutlined
  // vehicle: CarOutlined,
  // client: UsergroupAddOutlined,
  // dashboard: FundOutlined,
  // inventory:BarcodeOutlined,
  // service:ReconciliationOutlined,
  // provider:ContactsOutlined,
  // product: ProfileOutlined,
  // category: FileProtectOutlined,
  // invoice: FileDoneOutlined,
  // reception:FileDoneOutlined,
  // order:FileDoneOutlined,
  // myreception:FileDoneOutlined


  // Agrega más íconos según sea necesario
};

export default iconMap;
